import { useTranslation } from "src/hooks/translation";

import './style.scss';

const ProfitBoostInfo = () => {
  const t = useTranslation();

  return (
    <div className="B-profit-boost-info">
      <div className="B-stars" id="betslip-profit-boost-stars" />
      <div className="B-title">{t('Profit Boost')}</div>

      <p className="B-description">{t('You\'ve successfully claimed a profit boost! Just place one more bet to unlock and use it.')}</p>
    </div>
  )
}

export default ProfitBoostInfo;